import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import ClientSegmentAnalytics from "@/components/ClientSegmentAnalytics.vue";
import Visualization from "@/views/Visualization.vue";
import ESGDashboard from "@/views/ESGDashboard.vue";
import Infocenter from "@/views/ Infocenter.vue";
import Incidents from "@/views/Incidents.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView
  },
  {
    path: "/client-segment-analytics",
    name: "ClientSegmentAnalytics",
    component: ClientSegmentAnalytics
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: () => import("@/views/ContactUs.vue")
  },
  {
    path: "/visualization",
    name: "Visualization",
    component: Visualization
  },
  {
    path: "/esg",
    name: "ESG",
    component: ESGDashboard
  },
  {
    path: "/info-center",
    name: "InfoCenter",
    component: Infocenter
  },
  {
    path: "/incidents",
    name: "Incidents",
    component: Incidents
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
